import { render, staticRenderFns } from "./SolarwindsBackupPricing.vue?vue&type=template&id=490cbb94&"
import script from "./SolarwindsBackupPricing.vue?vue&type=script&lang=js&"
export * from "./SolarwindsBackupPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports